import IRequest from "../../IRequest";

export interface ICategoriasFinanceiras {
    reqCategorias: IRequest<TCategoriaFinanceiro>,
    dataCategorias: TCategoriaFinanceiro[]
  }

export type TCategoriaFinanceiro = {
  id: number;
  nome: string;
}

export const defValueCategoriaFinanceira: TCategoriaFinanceiro = 
{
  id: 0,
  nome: ''
}